import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum BaseExportFontSizeEnum {
    standard = 'standard',
    larger = 'larger',
    large = 'large',
    x_large = 'x-large',
}

export const baseExportFontSizeEnumOptions = enumToOptions(
    BaseExportFontSizeEnum,
    'enum.fontSize.',
);
